export {default} from "./serviceTypeBadge";
